import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AnalysisResult } from '@feedyou/utils'

export interface NlpAnalyzerState {
  analysisResult: AnalysisResult | null
  isFetching: boolean
  isBannerClosed: boolean
  isAnalysisUpToDate: boolean
}

const initialState: NlpAnalyzerState = {
  analysisResult: null,
  isBannerClosed: true,
  isFetching: false,
  isAnalysisUpToDate: true
}

const slice = createSlice({
  name: 'nlpAnalyzer',
  initialState,
  reducers: {
    request: (state, { payload: modelId }: PayloadAction<string>) => {
      state.isFetching = true
    },
    success: (state, action: PayloadAction<{ data: AnalysisResult }>) => {
      state.isFetching = false
      state.isAnalysisUpToDate = true
      state.isBannerClosed = false
      state.analysisResult = action.payload.data
    },
    failure: (state, { payload: modelId }: PayloadAction<string>) => {
      state.isFetching = false
    },
    setAnalysisOutOfDate: state => {
      state.isAnalysisUpToDate = false
    },
    closeBanner: state => {
      state.isBannerClosed = true
    }
  }
})

export const actions = slice.actions
export const reducer = slice.reducer
